import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { ElMessage } from 'element-plus'
import 'element-plus/dist/index.css'
import { User, Lock, Key } from '@element-plus/icons-vue'
import router from './router'
import App from './App.vue'

const app = createApp(App)

// 注册用到的图标（按需注册）
app.component('User', User)
app.component('Lock', Lock)
app.component('Key', Key)

// 挂载 ElMessage 到 app 上，使其在组件外可调用
app.config.globalProperties.$message = ElMessage

app.use(createPinia())
app.use(router)

app.mount('#app')
